export default __webpack_public_path__ + "static/poster-hospitality-e7c71e1daae0b4f2df7b8b9bfbf96674.jpg";